import React from "react";
import { motion } from "framer-motion";
import { Clock, CheckCircle2 } from "lucide-react";

export default function QuestionCard({ question, timeLeft, timeLimit, selectedIndex, answered, opponentAnswered, onSelect }) {
  const pct = Math.max(0, Math.round((timeLeft / timeLimit) * 100));
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="glass-panel rounded-2xl p-6" data-testid="duel-question-card">
      <div className="flex items-center justify-between mb-3">
        <span className="text-[10px] font-bold uppercase tracking-wider text-indigo-400" data-testid="duel-question-topic">
          Q{question.index + 1}/{question.total} · {question.topic}
        </span>
        <span className={`flex items-center gap-1 text-xs font-bold ${timeLeft <= 5 ? "text-red-400" : "text-slate-400"}`} data-testid="duel-timer">
          <Clock className="w-3.5 h-3.5" /> {timeLeft}s
        </span>
      </div>
      <div className="h-1 rounded-full bg-white/5 mb-4 overflow-hidden">
        <div className={`h-full transition-all duration-1000 linear ${timeLeft <= 5 ? "bg-red-400" : "bg-indigo-400"}`} style={{ width: `${pct}%` }} />
      </div>
      <h3 className="text-base sm:text-lg font-medium text-white mb-5 leading-relaxed" data-testid="duel-question-text">{question.question}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {question.options.map((opt, i) => {
          const isSelected = selectedIndex === i;
          return (
            <button
              key={i} onClick={() => !answered && onSelect(i)} disabled={answered} data-testid={`duel-option-${i}`}
              className={`text-left text-sm px-4 py-3 rounded-lg border transition-colors ${
                isSelected ? "border-indigo-400 bg-indigo-400/10 text-indigo-200" : "border-white/10 text-slate-300 hover:border-white/25"
              } ${answered && !isSelected ? "opacity-50" : ""}`}
            >
              {opt}
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-4 mt-4 text-xs text-slate-400">
        {answered && <span className="flex items-center gap-1 text-emerald-400" data-testid="duel-you-answered"><CheckCircle2 className="w-3.5 h-3.5" /> Answer locked in</span>}
        {opponentAnswered && <span className="flex items-center gap-1 text-amber-400" data-testid="duel-opponent-answered-indicator"><CheckCircle2 className="w-3.5 h-3.5" /> Opponent answered</span>}
      </div>
    </motion.div>
  );
}
